import { render, staticRenderFns } from "./ModalDataPerubahan.vue?vue&type=template&id=503e98c8&scoped=true&"
import script from "./ModalDataPerubahan.vue?vue&type=script&lang=js&"
export * from "./ModalDataPerubahan.vue?vue&type=script&lang=js&"
import style0 from "./ModalDataPerubahan.vue?vue&type=style&index=0&id=503e98c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503e98c8",
  null
  
)

export default component.exports